// extracted by mini-css-extract-plugin
export default {"row":"edit-metals_row__sycHF","item":"edit-metals_item__ijWRB"};